import useGoBack from 'utilities/navigation/back'
import { Field, Form, Formik } from 'formik'
import Header from 'components/headers/addLoan'
import WithDrawicon from 'assets/images/loans/withDraw.svg'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Num2persian from 'utilities/helper/num2Persian'
import { useState } from 'react'
import SelectModal from 'components/modals/selectModal'
import WithDrawTypeModal from 'components/modals/withDrawType'
import WithDrawWalletModal from 'components/modals/withDrawWallets'
import useGetCards from './hooks/useGetCards'
import { toast } from 'react-toastify'
import { Schema } from './utilities'
import TypeOneModal from './modals/type1'
import TypeTwoModal from './modals/type2'
import TypeThreeModal from './modals/type3'
import posthog from 'posthog-js'
import TypeFourModal from './modals/type4'
import TypeFiveModal from './modals/type5'
import useSetCashouts from './hooks/useSetCashouts'
import { NumericFormat } from 'react-number-format'
import { useEffect } from 'react'
import { useQuery } from 'react-query'
import { getWithdrawalCartable } from 'services/deposits'
import { toman } from 'utilities/helper/format'

interface ISelectUser {
    name: string
    id: undefined | number
    memberId: undefined | number
}
interface IReasonsModal {
    type: number
    isOpen: boolean
}
export default function WithDraw() {
    const [isOpenReceiver, setIsOpenReceiver] = useState<boolean>(false)
    const [isOpenTypeModal, setIsOpenTypeModal] = useState<boolean>(false)
    const [isOpenWalletModal, setIsOpenWalletModal] = useState<boolean>(false)
    const [selectedBankNumber, setSelectedBankNumber] = useState<number>(0)
    const [selectedUser, setSelectedUser] = useState<ISelectUser>()
    const [type, setType] = useState<undefined | number>()
    const [isOpenReasonsModal, setIsOpenReasonsModal] = useState<IReasonsModal>(
        { type: 0, isOpen: false }
    )
    const [memberId, setMemberId] = useState<undefined | number>()
    const params = useParams()
    const navigate = useNavigate()
    const goBack = useGoBack()
    const { state } = useLocation()
    const { mutate } = useSetCashouts()

    // درخواست برداشت awaiting money in this fund. Fetched even when the
    // manager arrived here by the ordinary «برداشت وجه» route, because the
    // whole point is that money paid down THAT path still counts against a
    // member's open request — a manager who used the button they already knew
    // must not leave the request looking untouched.
    const { data: cartable } = useQuery(
        ['admin-withdrawal-requests', params.id, ''],
        getWithdrawalCartable,
        { enabled: Boolean(params.id), staleTime: 30_000 }
    )
    const linkedRequest: IWithdrawalCartableRow | undefined =
        state?.withdrawalRequest ??
        (cartable?.results ?? []).find(
            (row) => row.poolship_id === selectedUser?.id
        )

    const {
        data,
        isLoading,
        activeAccount,
        activeAccounts,
        otherAccounts,
        handleSelectCard,
        reallySelectedCard,
    } = useGetCards(
        selectedUser?.id,
        selectedUser?.memberId,
        setSelectedBankNumber,
        // the member named an account when they filed the request; open on it
        linkedRequest?.bank_account_id ?? undefined
    )

    // arriving from the cartable: the member and the reason are already
    // decided, so answer them rather than making the manager re-pick
    useEffect(() => {
        if (!state?.withdrawalRequest) return
        const row: IWithdrawalCartableRow = state.withdrawalRequest
        setSelectedUser({
            name: row.member_name,
            id: row.poolship_id,
            // `useGetCards` matches accounts with `item.member === userId`, so
            // this has to be the MEMBER id. It used to be hard-coded
            // `undefined`, which matched nothing: the member's own cards were
            // filed under «سایر حساب‌ها», none was pre-selected, and the payout
            // went out with no destination account at all — the fund's balance
            // was debited and the transfer never reached the bank.
            memberId: row.member_id,
        })
        setType(0)
    }, [state])

    return (
        <>
            <Formik
                enableReinitialize
                initialValues={{
                    amount: state?.withdrawalRequest
                        ? String(state.withdrawalRequest.remaining)
                        : '',
                    tag: '',
                }}
                validationSchema={Schema}
                onSubmit={(values) => {
                    if (type !== undefined) {
                        if (selectedUser) {
                            if (Number(values.amount) >= 5000) {
                                const payload: IGetCardsPayloadFinal = {
                                    reason: type,
                                    registrar: Number(params.poolShip),
                                    poolship: Number(selectedUser?.id),
                                    amount: Number(values.amount),
                                    moneyPool: Number(params.id),
                                    tag: values.tag,
                                    bank_account:
                                        reallySelectedCard &&
                                        reallySelectedCard.id,
                                    ctx_id: params && Number(params.id),
                                    receiver: selectedUser?.memberId,
                                    name: selectedUser && selectedUser?.name,
                                    fundName: state?.name,
                                    withdrawal_request: linkedRequest?.id,
                                }
                                posthog.capture('withdrawal_started', {
                                    fund_id: params.id,
                                    reason: type,
                                    withdrawal_request_id: linkedRequest?.id,
                                })
                                navigate('/loans/withDraw/final', {
                                    state: { data: payload },
                                })
                            } else {
                                toast.error(
                                    'حداقل مبلغ برداشتی پنج هزار تومان می باشد'
                                )
                            }
                        } else {
                            toast.error('دریافت کننده را انتخاب کنید')
                        }
                    } else {
                        toast.error('مقداربابت ضروری می باشد')
                    }
                }}
            >
                {({ values, touched, errors, setFieldValue }) => (
                    <Form>
                        <div className=" mx-3 flex flex-col h-full ">
                            <div className=" grow-0">
                                <Header title="برداشت از صندوق" />
                            </div>
                            <div className="rounded-lg bg-white mt-14 mb-2 text-center pt-10 pb-2 grow-0 relative shadow-[0px_2px_6px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.08)]">
                                <img
                                    src={WithDrawicon}
                                    alt="add-loan"
                                    className=" absolute right-[35%] md:right-1/2 md:translate-x-1/2 -top-14"
                                />
                                <p className=" mb-2">موجودی صندوق:</p>
                                <p className=" text-black">
                                    {/* the cartable route does not carry the
                                     * balance, and `Number(undefined)` rendered
                                     * a literal «NaN تومان» there */}
                                    {Number.isFinite(Number(state?.exist))
                                        ? Number(state.exist).toLocaleString() +
                                          ' تومان'
                                        : '—'}
                                </p>
                            </div>
                            <div className=" rounded-lg grow">
                                <div className="  bg-white rounded-lg relative py-4 shadow-[0px_2px_6px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.08)]">
                                    <div className="  w-full text-center">
                                        {linkedRequest && (
                                            <div className=" mx-4 mb-3 rounded-lg bg-warning-soft px-3 py-2 text-right text-[11px] leading-6 text-warning-on">
                                                این عضو درخواست برداشت{' '}
                                                {toman(linkedRequest.amount)}{' '}
                                                ثبت کرده و{' '}
                                                {toman(linkedRequest.remaining)}{' '}
                                                آن باقی مانده است. این پرداخت به
                                                همان درخواست وصل می‌شود.
                                                {linkedRequest.debt > 0 && (
                                                    <>
                                                        {' '}
                                                        ایشان{' '}
                                                        {toman(
                                                            linkedRequest.debt
                                                        )}{' '}
                                                        هم به صندوق بدهکار
                                                        است.
                                                    </>
                                                )}
                                                {!linkedRequest.partial_accepted && (
                                                    <>
                                                        {' '}
                                                        عضو پرداخت بخشی از مبلغ
                                                        را نپذیرفته است.
                                                    </>
                                                )}
                                            </div>
                                        )}
                                        <p className=" text-sm text-center text-gray-1">
                                            مبلغ برداشت:
                                        </p>
                                        <NumericFormat
                                            customInput={Field}
                                            thousandSeparator
                                            allowNegative={false}
                                            name="amount"
                                            placeholder="مبلغ(تومان)"
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                            defaultValue={values.amount}
                                            isGray
                                            secondaryTitle="| تومان "
                                            onValueChange={(values) => {
                                                const { value } = values
                                                setFieldValue('amount', value)
                                            }}
                                        />
                                        {/* <Field
                                            type="number"
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                            placeholder="مبلغ(تومان)"
                                            name="amount"
                                            min={0}
                                        /> */}
                                        {values.amount !== '' && (
                                            <span className=" text-xs text-blue-1 text-center w-full">
                                                {Num2persian(
                                                    values.amount.toString()
                                                )}{' '}
                                                تومان
                                            </span>
                                        )}
                                        {errors.amount && touched.amount && (
                                            <p className=" text-sm text-error-3 text-center">
                                                {errors.amount}
                                            </p>
                                        )}

                                        <div
                                            onClick={() =>
                                                setIsOpenReceiver(true)
                                            }
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3 text-placeholder bg-white"
                                        >
                                            {selectedUser?.name
                                                ? selectedUser?.name
                                                : ' دریافت کننده'}
                                        </div>

                                        <div
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3 text-placeholder bg-white"
                                            onClick={() =>
                                                setIsOpenTypeModal(true)
                                            }
                                        >
                                            {type === 0
                                                ? 'برداشت سرمایه شخصی'
                                                : type === 1
                                                  ? ' عودت قرض مدت دار، واریز اشتباه یا اضافه'
                                                  : type === 2
                                                    ? ' برنامه های جانبی فرهنگی و امور خیریه بلاعوض'
                                                    : type === 3
                                                      ? 'تامین مالی هزینه کرد از محل درآمد صندوق'
                                                      : type === 4
                                                        ? 'سایر'
                                                        : 'بابت'}
                                        </div>

                                        <div
                                            onClick={() => {
                                                selectedUser
                                                    ? setIsOpenWalletModal(true)
                                                    : toast.error(
                                                          'دریافت کننده را انتخاب کنید'
                                                      )
                                            }}
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3 text-placeholder bg-white"
                                        >
                                            {reallySelectedCard
                                                ? reallySelectedCard.full_name +
                                                  '-' +
                                                  reallySelectedCard.bank_name
                                                : 'شماره حساب'}
                                        </div>
                                        <Field
                                            as="textarea"
                                            name="tag"
                                            className="w-full outline-0 text-center py-4 px-4 text-sm"
                                            placeholder="توضیحات"
                                        />
                                        {errors.tag && touched.tag && (
                                            <p className=" text-sm text-error-3 text-center">
                                                {errors.tag}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <button
                                className=" grow-0 bg-green-1 text-white py-3 rounded-lg mt-3"
                                type="submit"
                            >
                                برداشت
                            </button>
                            <button
                                type="button"
                                className=" text-center my-3 text-gray-4"
                                onClick={goBack}
                            >
                                بعدا
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
            <SelectModal
                show={isOpenReceiver}
                onHide={() => setIsOpenReceiver(false)}
                setSelectedUser={setSelectedUser}
                setMemberId={setMemberId}
            />
            <WithDrawTypeModal
                show={isOpenTypeModal}
                onHide={() => setIsOpenTypeModal(false)}
                setType={setIsOpenReasonsModal}
            />
            <WithDrawWalletModal
                show={isOpenWalletModal}
                onHide={() => setIsOpenWalletModal(false)}
                data={!isLoading && data && data.receivers[0].bankaccounts}
                activeAccounts={activeAccounts}
                otherAccounts={otherAccounts}
                selectedUser={selectedUser?.name}
                setSelectedBankNumber={setSelectedBankNumber}
                handleSelectCard={handleSelectCard}
            />
            <TypeOneModal
                show={
                    isOpenReasonsModal.type === 0 && isOpenReasonsModal.isOpen
                }
                onHide={() => setIsOpenReasonsModal({ type: 0, isOpen: false })}
                setType={setType}
            />
            <TypeTwoModal
                show={
                    isOpenReasonsModal.type === 1 && isOpenReasonsModal.isOpen
                }
                onHide={() => setIsOpenReasonsModal({ type: 1, isOpen: false })}
                setType={setType}
            />
            <TypeThreeModal
                show={
                    isOpenReasonsModal.type === 2 && isOpenReasonsModal.isOpen
                }
                onHide={() => setIsOpenReasonsModal({ type: 2, isOpen: false })}
                setType={setType}
            />
            <TypeFourModal
                show={
                    isOpenReasonsModal.type === 3 && isOpenReasonsModal.isOpen
                }
                onHide={() => setIsOpenReasonsModal({ type: 3, isOpen: false })}
                setType={setType}
            />
            <TypeFiveModal
                show={
                    isOpenReasonsModal.type === 4 && isOpenReasonsModal.isOpen
                }
                onHide={() => setIsOpenReasonsModal({ type: 4, isOpen: false })}
                setType={setType}
            />
        </>
    )
}
